module.exports = __webpack_public_path__ + "img/lukoil-logo-white.eebe3648.png";